export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden mt- md:mt-16 min-h-[680px] md:min-h-[700px]">
      <div
        className="block md:hidden absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/img/contact-us/Backgroundimagephone.png')" }}
      />

      {/* Desktop background */}
      <div
        className="hidden md:block absolute inset-0 bg-cover bg-center bg-no-repeat "
        style={{ backgroundImage: "url('/img/contact-us/Backgroundimage1.png')" }}
      />

      {/* Overlay text content */}
     <div
  className="absolute inset-0 flex flex-col items-center text-center z-10
             pt-20 sm:pt-16
             md:items-start md:text-left md:justify-center md:pb-[210px] md:pr-0 md:pt-0
             md:pl-[clamp(24px,5vw,100px)]"
>
        <div
          className="mx-auto md:mx-0 flex flex-col items-center md:items-start"
          style={{ maxWidth: "clamp(240px, 32vw, 420px)" }}
        >
          {/* Contact us badge - ab mobile aur desktop dono par */}
          <span className="inline-flex items-center gap-2 bg-white/90 text-[#7209B7] text-brand-600 text-sm font-semibold px-4 py-1.5 rounded-full shadow-sm border border-brand-100 mb-3 w-fit">
            <img
              src="/img/shared/safety-badge.svg"
              alt="Shield Check"
              className="w-4 h-4"
            />
            Contact us
          </span>

          {/* Heading */}
          <h1 className="font-extrabold tracking-tight leading-[1.08] whitespace-nowrap text-[7vw] sm:text-[6vw] md:text-[4.2vw] lg:text-[4vw] text-gray-900 mb-2">
            Get in <span className="text-[#7209B7]">Touch</span>
          </h1>

          {/* Description */}
          <p className="mt-0 md:mt- text-[15px] md:text-base text-gray-600 leading-relaxed">
            Have questions, feedback, or need assistance? We're here to help you
            every step of your journey.
          </p>
        </div>
      </div>
    </section>
  );
}
